module.exports = __webpack_public_path__ + "img/HDB_Authorised_Eika.3f7866ed.png";